import React from "react";
import { ReactNode } from "react";
import { useQuestionizerStore } from "../types/state.ts";

type SelectValue = string | number;

export default function Select<T> (props: {id: string, value: T | undefined, children: ReactNode, onChange: (value: T) => void, label: string, onBlur?: ()=>void}){
  const validation_inputs = useQuestionizerStore((state) => state.validation_inputs);
  const error = validation_inputs[props.id];
  const has_error = error !== undefined && !error.valid;
  const escaped_label = props.label.replaceAll("&shy;","");
  
  return (
    <>
      <label id={"text-input-label-"+props.id} className={"text-input__label " + (props.value as string != "" ? "text-input__has_content" : "")} dangerouslySetInnerHTML={{__html: props.label}}></label>
      <div className={"select-input"}>
        <select 
            id={props.id}
            tabIndex={0}
            aria-label={escaped_label}
            className="select-input__input" 
            value={props.value as SelectValue} 
            onChange={(e)=> props.onChange(e.target.value as T)}
            onBlur={props.onBlur}
            aria-invalid={has_error}
            aria-describedby={"email-error-"+props.id}
          >
          {React.Children.map(props.children, (child) => {
            if (React.isValidElement(child) && child.props.value !== undefined) {
              return React.cloneElement(child);
            }
            return child;
          })}
        </select> 
        {has_error ? 
          <span className={"select-input__error"} id={"email-error-"+props.id} role="alert">{error.message}</span> :
          <span className={"select-input__error"} id={"email-error-"+props.id} style={{display: "none"}}></span>
        }
      </div>
    </>

    );
}